import React from "react";

// Sticky right-rail "Page Sections" list of in-page anchors with the current
// section highlighted (same look as the Update Journey rail). `children` render
// as extra cards under it (e.g. a "Related" card or actions).
// sections: [{ id, label, icon: LucideComponent }]
export default function TspSectionNav({ title = "Page Sections", sections, activeId, onSelect, children }) {
  return (
    <aside className="tsp-journey-section-nav">
      <nav className="tsp-card" aria-label={title}>
        <h4 className="tsp-section-nav-title">{title}</h4>
        <ul className="tsp-section-nav-list">
          {sections.map(({ id, label, icon: Icon }) => (
            <li key={id}>
              <a href={`#${id}`} className={id === activeId ? "active" : ""} aria-current={id === activeId ? "location" : undefined} onClick={() => onSelect?.(id)}>
                {Icon && <Icon size={16} aria-hidden="true" />}
                {label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
      {children}
    </aside>
  );
}
